function openFullScreen() {
  const fullScreen = '{"MsdkMethod":"WGSetFullScreen","isFullScreen":"true"}';
  window.msdkCall('WGSetFullScreen', fullScreen);
}

function closeFullScreen() {
  const fullScreen = '{"MsdkMethod":"WGSetFullScreen","isFullScreen":"false"}';
  window.msdkCall('WGSetFullScreen', fullScreen);
}

export { openFullScreen, closeFullScreen };
